import React from "react";
import ColumnZero1 from '../components/ColumnZero1';
import ColumnZeroTwo from '../components/ColumnZeroTwo';
import Footer from '../components/footer';
import { createGlobalStyle } from 'styled-components';


const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    background: #212428;
  }
`;

const Explore = function () {
    const [openMenu, setOpenMenu] = React.useState(true);
    const [openMenu1, setOpenMenu1] = React.useState(false);
    const handleBtnClick = (): void => {
        setOpenMenu(!openMenu);
        setOpenMenu1(false);
        document.getElementById("Mainbtn").classList.add("active");
        document.getElementById("Mainbtn1").classList.remove("active");
    };
    const handleBtnClick1 = (): void => {
        setOpenMenu1(!openMenu1);
        setOpenMenu(false);
        document.getElementById("Mainbtn1").classList.add("active");
        document.getElementById("Mainbtn").classList.remove("active");
    };



    return (
        <div>
            <GlobalStyles />

            <section id='profile_banner' className='jumbotron breadcumb no-bg' style={{ backgroundImage: `url(${'./img/background/1.jpg'})` }}>
                <div className='mainbreadcumb'>
                </div>
            </section>

            <section className='container d_coll no-top no-bottom'>
                <div className='row'>
                    <div className="col-md-12">
                        <div className="d_profile">
                            <div className="profile_avatar">
                                <div className="d_profile_img">
                                    <img src="./img/author/santa.jpg" alt="" />
                                    <i className="fa fa-check"></i>
                                </div>
                                <div className="profile_name">
                                    <h4> All Collections(3,600+)
                                        <div className="clearfix"></div>
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='container no-top'>
                <div className='row'>
                    <div className='col-lg-12'>
                        {/* <div className="items_filter">
                <ul className="de_nav">
                    <li id='Mainbtn' className="active"><span onClick={handleBtnClick}>On Sale</span></li>
                </ul>
            </div> */}
                    </div>
                </div>
                {openMenu && (
                    <div id='zero1' className='onStep fadeIn'>
                        <ColumnZero1 />
                    </div>
                )}
                
            </section>
            <Footer />
        </div>
    );
}
export default Explore;